(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dorner-parts-filter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dorner-parts-filters')) {
    customElements.define('dorner-parts-filters', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const form = this.querySelector('form');
        if (!form) return;
        this.initialized = true;
        const read = selector => JSON.parse(this.querySelector(selector).textContent);
        const tags = read('[data-dpf-tags]') || [];
        const current = read('[data-dpf-current]') || [];
        const labels = read('[data-dpf-labels]');
        const selects = [...this.querySelectorAll('select[data-prefix]')];
        const isManaged = tag => selects.some(select => tag.startsWith(select.dataset.prefix));
        const otherTags = current.filter(tag => !isManaged(tag));
        const readable = (tag, prefix) => labels[tag] || tag.slice(prefix.length).split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        for (const select of selects) {
          const prefix = select.dataset.prefix;
          const options = [...new Set([...tags, ...current])].filter(tag => tag.startsWith(prefix));
          options.sort((a, b) => readable(a, prefix).localeCompare(readable(b, prefix), undefined, {numeric: true}));
          for (const tag of options) select.add(new Option(readable(tag, prefix), tag, false, false));
          select.value = current.find(tag => tag.startsWith(prefix)) || '';
        }
        const destination = selected => {
          const url = new URL(window.location.href);
          const chosen = [...new Set([...otherTags, ...selected.filter(Boolean)])];
          url.pathname = this.dataset.base.replace(/\/$/, '') + (chosen.length ? '/' + chosen.map(encodeURIComponent).join('+') : '');
          url.searchParams.delete('page');
          url.searchParams.delete('section_id');
          url.searchParams.delete('sections');
          url.hash = '';
          return url;
        };
        form.addEventListener('submit', event => {
          event.preventDefault();
          window.location.assign(destination(selects.map(select => select.value)).href);
        });
        const clear = this.querySelector('.dpf-clear');
        clear.href = destination([]).href;
        clear.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          window.location.assign(destination([]).href);
        });
        form.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
